'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const activeCalendarModule = angular
  .module('app.active-calendar', [])
  .config(activeCalendarConfig);

activeCalendarConfig.$inject = ['$routeProvider'];

function activeCalendarConfig($routeProvider) {
  $routeProvider
    .when('/active-calendar/registration', {
      template: `<ngz-registration></ngz-registration>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
      },
    })
    .when('/active-calendar/users', {
      template: `<ngz-active-calendar-users></ngz-active-calendar-users>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Active Calendar Users', icon: NAVIGATION_ICON.LIST_ALT }
        ]
      }
    });
}
